import styleCatalogCarousel from "./CatalogCarousel.module.css";
import CatalogCard from "../CatalogCard/CatalogCard";
import { Carousel } from "antd";
import { Link } from "react-router-dom";

const CatalogCarousel = ({
  sidepanelData,
  showSidePanel,
  sceneId,
}) => {
  const card = sidepanelData?.id
    ? {
        title: sidepanelData.title,
        description: sidepanelData.description,
        image: sidepanelData.sidepanelImage,
        id: sidepanelData.id,
      }
    : null;

  return (
    <section className={styleCatalogCarousel["catalog-carousal-container"]}>
      <Carousel className={styleCatalogCarousel["catalog-carousel"]}>
        {card && (
          <CatalogCard
            title={card.title}
            id={card.id}
            description={card.description}
            sidepanelImage={card.image}
            showSidePanel={showSidePanel}
            sectorOrSidepanel={"sidepanel"}
            sceneId={sceneId}
          />
        )}
      </Carousel>

      {card?.id && (
        <Link
          to={`/scene/${card.id}`}
          className={styleCatalogCarousel["card-explore-btn"]}
        >
          Explore
        </Link>
      )}
    </section>
  );
};

export default CatalogCarousel;
